import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import RightSidebar from './RightSidebar';
import SettingsModal from './SettingsModal';
import './SubpageLayout.css';

const SubpageLayout = ({ children, backLabel = 'Back' }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [isActivityCollapsed, setIsActivityCollapsed] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);

    const goMain = () => {
        if (user?.uid) navigate(`/main/${user.uid}`);
        else navigate('/');
    };

    const handleBack = () => {
        if (typeof window !== 'undefined' && window.history.length > 1) {
            navigate(-1);
            return;
        }
        goMain();
    };

    return (
        <div className="subpage-layout">
            <RightSidebar
                isCollapsed={isActivityCollapsed}
                onCollapse={setIsActivityCollapsed}
                isMobileOpen={false}
                onMobileClose={() => {}}
                user={user}
                documents={[]}
                currentDocumentId={null}
                onToggleChat={goMain}
                onToggleQuiz={goMain}
                onToggleFlashcards={goMain}
            />
            <div
                className={`subpage-layout__main ${
                    isActivityCollapsed ? 'subpage-layout__main--activity-collapsed' : 'subpage-layout__main--activity-expanded'
                }`}
            >
                <header className="subpage-layout__topbar">
                    <button type="button" className="subpage-layout__back" onClick={handleBack}>
                        <ArrowLeft size={18} aria-hidden />
                        {backLabel}
                    </button>
                    <button
                        type="button"
                        className="subpage-layout__settings-btn"
                        onClick={() => setShowSettingsModal(true)}
                        title="Settings"
                        aria-label="Open settings"
                    >
                        <Settings size={20} aria-hidden />
                    </button>
                </header>
                <div className="subpage-layout__body">{children}</div>
            </div>
            {showSettingsModal && (
                <SettingsModal
                    onClose={() => setShowSettingsModal(false)}
                    user={user}
                />
            )}
        </div>
    );
};

export default SubpageLayout;
